import React from 'react'

import { useQuery } from '@apollo/client'
import { MY_PROJECTS_QUERY } from 'config/operations'

import Wait from '@react/react-spectrum/Wait'

import UserProjects from './UserProjects'

import './Projects.scss'

export default function Projects() {
  const { loading, error, data } = useQuery(MY_PROJECTS_QUERY)

  const projects = data?.myProjects

  return (
    <div className='projects'>
      {loading && <LoadingState />}
      {error && <ErrorState error={error} />}
      {!loading && !error && (
        <>
          <UserProjects projects={projects} />
        </>
      )}
    </div>
  )
}

function LoadingState() {
  return (
    <div className='projects__loading'>
      <Wait size='L' />
      <em>Loading your projects...</em>
    </div>
  )
}

function ErrorState(error) {
  console.error(error)
  return (
    <div className='projects__loading'>
      <em>Could not load project list.</em>
      <em>{error}</em>
    </div>
  )
}
